export interface ProjectRemoteConfig {
  studio: string;
  disabled: boolean;
  facebookAppSecret: string;
}

export function parseProjectRemoteConfig(
  remoteJson: string,
): ProjectRemoteConfig {
  let studio = null;
  let disabled = false;
  let facebookAppSecret = '';
  try {
    const dataObj = JSON.parse(remoteJson);
    if ('studio' in dataObj) studio = dataObj.studio;
    if ('disabled' in dataObj) disabled = dataObj.disabled;
    if ('facebookAppSecret' in dataObj)
      facebookAppSecret = dataObj.facebookAppSecret;
  } catch {}

  return {
    studio,
    disabled,
    facebookAppSecret,
  };
}
